<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
  <div class="wrapper">
    <app-header></app-header>
    <app-sidebar [page]="'dealslip'" [subPage]="'dealslip'"></app-sidebar>

    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0">Dealslip</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active">Dealslip</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section class="content">
        <div class="container-fluid">
          <app-module-menu [module]="'treasury'" [activeSlug]="'dealslip'"></app-module-menu>
          <div class="row">
            <div class="modal fade" id="modal-dealslip-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('dealSlip') || checkService.canModify('dealSlip')">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
              <div class="card card-primary card-outline mb-0">
                <div class="card-header">
                  <h4 class="card-title">{{ formHeader }}</h4>
                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="onCancel()"><i class="fas fa-times"></i></button>
                  </div>
                </div>
                <form [formGroup]="dataForm">
                  <div class="card-body">
                    <div class="form-group">
                      <label for="client">Client</label>
                      <input type="text" class="form-control" id="client" [value]="clientLabel" (input)="onClientChange($any($event.target).value)" list="dealslip-user-options" placeholder="Search and select client">
                      <input type="hidden" formControlName="client">
					  <small class="form-text text-success" *ngIf="dataForm.value.customerType === 'onboarded' && dataForm.value.client">Customer type: Onboarded with ID {{ dataForm.value.client }}</small>
					  <small class="form-text text-info" *ngIf="dataForm.value.customerType === 'walk-in' && clientLabel.trim()">Customer type: Walk-in</small>
					  <input type="hidden" formControlName="customerType">
                    </div>
					<div *ngIf="dataForm.value.customerType === 'walk-in'" class="row">
					  <div class="col-md-6 form-group"><label for="walkInFirstName">First Name</label><input class="form-control" id="walkInFirstName" formControlName="walkInFirstName"></div>
					  <div class="col-md-6 form-group"><label for="walkInLastName">Last Name</label><input class="form-control" id="walkInLastName" formControlName="walkInLastName"></div>
					  <div class="col-md-6 form-group"><label for="walkInPhone">Phone</label><input class="form-control" id="walkInPhone" formControlName="walkInPhone"></div>
					  <div class="col-md-6 form-group"><label for="walkInEmail">Email (optional)</label><input type="email" class="form-control" id="walkInEmail" formControlName="walkInEmail"><small class="form-text text-muted">Walk-in customers do not receive dealslip emails.</small></div>
					</div>
                    <div class="form-group">
                      <label for="sellAmount">Sell Amount</label>
                      <input type="number" step="0.01" class="form-control" formControlName="sellAmount" id="sellAmount" placeholder="0.00" (input)="updateRateFromAmounts()">
                    </div>
                    <div class="form-group">
                      <label for="sellCurrency">Sell Currency</label>
                      <select class="form-control" formControlName="sellCurrency" id="sellCurrency">
                        <option value="">Select One</option>
                        <option *ngFor="let currency of currencyOptions" [value]="currency.code">{{ currency.code }} - {{ currency.name }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="buyAmount">Buy Amount</label>
                      <input type="number" step="0.01" class="form-control" formControlName="buyAmount" id="buyAmount" placeholder="0.00" (input)="updateRateFromAmounts()">
                    </div>
                    <div class="form-group">
                      <label for="buyCurrency">Buy Currency</label>
                      <select class="form-control" formControlName="buyCurrency" id="buyCurrency">
                        <option value="">Select One</option>
                        <option *ngFor="let currency of currencyOptions" [value]="currency.code">{{ currency.code }} - {{ currency.name }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="date">Deal Date</label>
                      <input type="datetime-local" class="form-control" formControlName="date" id="date">
                    </div>
                    <div class="form-group">
                      <label for="rate">Rate</label>
					  <input type="number" step="0.000001" class="form-control" formControlName="rate" id="rate" placeholder="0.000000" (input)="updateBuyAmountFromRate()">
                      <small class="form-text text-muted" *ngIf="formMarketRate">
                        Market rate: <strong>{{ formMarketRate }}</strong>
                      </small>
                    </div>
                    <div class="form-group">
                      <label>Status</label>
                      <input type="text" class="form-control" value="Pending" disabled>
                      <small class="form-text text-muted">All new dealslips are created with pending status.</small>
                    </div>
                  </div>
                  <div class="card-footer">
                    <input type="hidden" formControlName="ref">
                    <button type="submit" [disabled]="!dataForm.valid || processing" (click)="onCreate()" class="btn btn-primary">{{ buttonText }}</button>
                    <button type="button" data-dismiss="modal" (click)="onCancel()" class="btn btn-secondary ml-2">Cancel</button>
                  </div>
                </form>
              </div>
                </div>
              </div>
            </div>

            <div class="modal fade" id="modal-dealslip-filter" tabindex="-1" role="dialog" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
              <div class="card card-secondary card-outline mb-0">
                <div class="card-header">
                  <h4 class="card-title">Search Filters</h4>
                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-dismiss="modal"><i class="fas fa-times"></i></button>
                  </div>
                </div>
                <form [formGroup]="searchForm">
                  <div class="card-body">
                    <div class="form-group">
                      <label>Date From</label>
                      <input type="date" class="form-control" formControlName="dateFrom">
                    </div>
                    <div class="form-group">
                      <label>Date To</label>
                      <input type="date" class="form-control" formControlName="dateTo">
                    </div>
                    <div class="form-group">
                      <label>Status</label>
                      <select class="form-control" formControlName="status">
                        <option value="">All</option>
                        <option value="new">New</option>
                        <option value="pending">Pending</option>
                        <option value="complete">Complete</option>
                        <option value="cancel">Cancel</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Sell Currency</label>
                      <select class="form-control" formControlName="sellCurrency">
                        <option value="">All</option>
                        <option *ngFor="let currency of currencyOptions" [value]="currency.code">{{ currency.code }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Buy Currency</label>
                      <select class="form-control" formControlName="buyCurrency">
                        <option value="">All</option>
                        <option *ngFor="let currency of currencyOptions" [value]="currency.code">{{ currency.code }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>User</label>
                      <input type="text" class="form-control" [value]="searchUserLabel" (input)="onSearchUserChange($any($event.target).value)" list="dealslip-user-options" placeholder="Search and select user">
                      <small class="form-text text-muted" *ngIf="searchForm.value.user">Selected ID: {{ searchForm.value.user }}</small>
                    </div>
                    <div class="form-group">
                      <label>Created By</label>
                      <input type="text" class="form-control" [value]="searchCreatedAdminLabel" (input)="onSearchCreatedAdminChange($any($event.target).value)" list="dealslip-admin-options" placeholder="Search and select admin">
                      <small class="form-text text-muted" *ngIf="searchForm.value.createdAdmin">Selected ID: {{ searchForm.value.createdAdmin }}</small>
                    </div>
                    <div class="form-group">
                      <label>Modified By</label>
                      <input type="text" class="form-control" [value]="searchModifiedAdminLabel" (input)="onSearchModifiedAdminChange($any($event.target).value)" list="dealslip-admin-options" placeholder="Search and select admin">
                      <small class="form-text text-muted" *ngIf="searchForm.value.modifiedAdmin">Selected ID: {{ searchForm.value.modifiedAdmin }}</small>
                    </div>
                  </div>
                  <div class="card-footer">
                    <button type="button" class="btn btn-primary" [disabled]="searchLoading" data-dismiss="modal" (click)="onSearch()">Search</button>
                    <button type="button" class="btn btn-secondary ml-2" (click)="resetSearch()">Reset</button>
                  </div>
                </form>
              </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-primary card-outline">
                <div class="card-header">
                  <h3 class="card-title">Dealslip Dashboard</h3>
                </div>
                <div class="card-body">
                  <form [formGroup]="dashboardForm" class="mb-3">
                    <div class="row">
                      <div class="col-md-3 form-group">
                        <label>Date From</label>
                        <input type="date" class="form-control" formControlName="dateFrom">
                      </div>
                      <div class="col-md-3 form-group">
                        <label>Date To</label>
                        <input type="date" class="form-control" formControlName="dateTo">
                      </div>
                      <div class="col-md-2 form-group">
                        <label>User</label>
                        <input type="text" class="form-control" [value]="dashboardUserLabel" (input)="onDashboardUserChange($any($event.target).value)" list="dealslip-user-options" placeholder="Select user">
                        <small class="form-text text-muted" *ngIf="dashboardForm.value.user">ID: {{ dashboardForm.value.user }}</small>
                      </div>
                      <div class="col-md-2 form-group">
                        <label>Created By</label>
                        <input type="text" class="form-control" [value]="dashboardCreatedAdminLabel" (input)="onDashboardCreatedAdminChange($any($event.target).value)" list="dealslip-admin-options" placeholder="Select admin">
                        <small class="form-text text-muted" *ngIf="dashboardForm.value.createdAdmin">ID: {{ dashboardForm.value.createdAdmin }}</small>
                      </div>
                      <div class="col-md-2 form-group">
                        <label>Modified By</label>
                        <input type="text" class="form-control" [value]="dashboardModifiedAdminLabel" (input)="onDashboardModifiedAdminChange($any($event.target).value)" list="dealslip-admin-options" placeholder="Select admin">
                        <small class="form-text text-muted" *ngIf="dashboardForm.value.modifiedAdmin">ID: {{ dashboardForm.value.modifiedAdmin }}</small>
                      </div>
                    </div>
                    <button type="button" class="btn btn-primary btn-sm" [disabled]="dashboardLoading" (click)="loadDashboard()">Refresh</button>
                    <button type="button" class="btn btn-secondary btn-sm ml-2" (click)="resetDashboard()">Reset</button>
                  </form>

                  <div class="row">
                    <div class="col-md-3">
                      <div class="small-box bg-info">
                        <div class="inner">
                          <h3>{{ dashboardData.data.totalDeals || 0 }}</h3>
                          <p>Total Deals</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="small-box bg-primary">
                        <div class="inner">
                          <h3>{{ dashboardData.data.status.new || 0 }}</h3>
                          <p>New</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="small-box bg-success">
                        <div class="inner">
                          <h3>{{ dashboardData.data.status.complete || 0 }}</h3>
                          <p>Complete</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="small-box bg-danger">
                        <div class="inner">
                          <h3>{{ dashboardData.data.status.cancel || 0 }}</h3>
                          <p>Cancel</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <h5>Sell Currency Totals</h5>
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th>Currency</th>
                            <th>Deals</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of dashboardData.data.sellCurrency">
                            <td>{{ row.currency.code }}</td>
                            <td>{{ row.totalDeals }}</td>
                            <td>{{ row.totalAmount | number:'1.2-2' }}</td>
                          </tr>
                          <tr *ngIf="dashboardData.data.sellCurrency.length == 0">
                            <td colspan="3" class="text-center">No data</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-6">
                      <h5>Buy Currency Totals</h5>
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th>Currency</th>
                            <th>Deals</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of dashboardData.data.buyCurrency">
                            <td>{{ row.currency.code }}</td>
                            <td>{{ row.totalDeals }}</td>
                            <td>{{ row.totalAmount | number:'1.2-2' }}</td>
                          </tr>
                          <tr *ngIf="dashboardData.data.buyCurrency.length == 0">
                            <td colspan="3" class="text-center">No data</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <datalist id="dealslip-user-options">
                <option *ngFor="let option of userOptions" [value]="option.label"></option>
              </datalist>

              <datalist id="dealslip-admin-options">
                <option *ngFor="let option of adminOptions" [value]="option.label"></option>
              </datalist>

              <div class="card card-primary card-outline">
                <img [hidden]="!loading" [class]="loading ? 'mx-auto d-block' : ''" src="assets/LoadingGIF/Rolling-1s-75px.gif">
                <div class="card card-solid" [hidden]="loading">
                  <div class="card-header">
                    <h3 class="card-title">{{ mainHeader }}</h3>
                    <div class="text-right">
                      <div class="btn-group">
                        <button type="button" class="btn btn-primary btn-sm" *ngIf="checkService.canWrite('dealSlip')" data-toggle="modal" data-target="#modal-dealslip-form" (click)="onCancel()">
                          <i class="fas fa-plus"></i> Create Dealslip
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm" data-toggle="modal" data-target="#modal-dealslip-filter">
                          <i class="fas fa-filter"></i> Filters
                        </button>
                        <a [routerLink]="['/dealslip']" class="btn btn-primary btn-sm">All</a>
                        <a [routerLink]="['/dealslip/new']" class="btn btn-primary btn-sm">New</a>
                        <a [routerLink]="['/dealslip/pending']" class="btn btn-primary btn-sm">Pending</a>
                        <a [routerLink]="['/dealslip/complete']" class="btn btn-primary btn-sm">Complete</a>
                        <a [routerLink]="['/dealslip/cancel']" class="btn btn-primary btn-sm">Cancel</a>
                      </div>
                    </div>
                  </div>
                  <div class="card-body table-responsive p-0">
                    <table class="table table-hover text-nowrap">
                      <thead>
                        <tr>
                          <th>Ref</th>
                          <th>Client</th>
                          <th>Sell</th>
                          <th>Buy</th>
                          <th>Status</th>
                          <th>Creator</th>
                          <th>Deal Date</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dealslipRow of dealslipList">
                          <td>#{{ dealslipRow.ref }}</td>
                          <td>{{ printClient(dealslipRow) }}</td>
                          <td>{{ dealslipRow.sellAmount | number:'1.2-2' }} {{ dealslipRow.sellCurrency.code }}</td>
                          <td>{{ dealslipRow.buyAmount | number:'1.2-2' }} {{ dealslipRow.buyCurrency.code }}</td>
                          <td>
                            <span class="badge bg-warning" *ngIf="dealslipRow.status.pending">Pending</span>
                            <span class="badge bg-primary" *ngIf="dealslipRow.status.new">New</span>
                            <span class="badge bg-success" *ngIf="dealslipRow.status.complete">Complete</span>
                            <span class="badge bg-danger" *ngIf="dealslipRow.status.cancel">Cancel</span>
                            <span class="badge bg-info" *ngIf="dealslipRow.status.active">Active</span>
                            <span class="badge bg-secondary" *ngIf="dealslipRow.status.inactive">Inactive</span>
                          </td>
                          <td>{{ printAdminName(dealslipRow.createdBy) }}</td>
                          <td>{{ dealslipRow.date }}</td>
                          <td>
                            <div class="btn-group btn-group-sm" *ngIf="hasManageOptions(dealslipRow)">
                              <button type="button" class="btn btn-secondary" title="View" (click)="viewDealslip(dealslipRow)">
                                <i class="fas fa-eye"></i>
                              </button>
                              <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify('dealSlip')" data-toggle="modal" data-target="#modal-dealslip-form" (click)="getEdit(dealslipRow)">
                                <i class="fas fa-edit"></i>
                              </button>
                              <button type="button" *ngIf="canMarkNew(dealslipRow) && checkService.canModify('dealSlip')" class="btn btn-primary" title="Mark New" (click)="changeDealslipStatus('new', dealslipRow.ref)">
                                <i class="fas fa-plus"></i>
                              </button>
                              <button type="button" *ngIf="canMarkComplete(dealslipRow) && checkService.canModify('dealSlip')" class="btn btn-success" title="Mark Complete" (click)="changeDealslipStatus('complete', dealslipRow.ref)">
                                <i class="fas fa-check"></i>
                              </button>
                              <button type="button" *ngIf="canMarkCancel(dealslipRow) && checkService.canModify('dealSlip')" class="btn btn-warning" title="Mark Cancel" (click)="changeDealslipStatus('cancel', dealslipRow.ref)">
                                <i class="fas fa-ban"></i>
                              </button>
                              <button type="button" *ngIf="canDeleteDealslip(dealslipRow) && checkService.canModify('dealSlip')" class="btn btn-danger" title="Delete" (click)="deleteDealslip(dealslipRow.ref)">
                                <i class="fas fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr *ngIf="dealslipList.length == 0">
                          <td colspan="8" class="text-center">No record to show</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer" *ngIf="dealslipList.length > 0 && count">
                    <app-pagination [url]="url" [counts]="count" (refresh)="routePage($event)"></app-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="side-drawer-backdrop" *ngIf="viewOne" (click)="closeDealslipDrawer()"></div>
    <aside class="side-drawer" *ngIf="viewOne && oneDealslip">
      <div class="side-drawer-header">
        <div class="drawer-avatar drawer-avatar-icon"><i class="fas fa-file-invoice"></i></div>
        <div class="drawer-title">
          <h3>Dealslip #{{ oneDealslip.ref }}</h3>
          <p>{{ printClient(oneDealslip) }}</p>
        </div>
        <span class="drawer-status">
          <i class="fas fa-circle"></i>
          {{ oneDealslip.status.complete ? 'complete' : oneDealslip.status.pending ? 'pending' : oneDealslip.status.cancel ? 'cancelled' : oneDealslip.status.new ? 'new' : 'active' }}
        </span>
        <button type="button" class="drawer-close" aria-label="Close details" (click)="closeDealslipDrawer()"><i class="fas fa-times"></i></button>
      </div>
      <div class="drawer-tabs">
        <button type="button" class="active">Details</button>
      </div>
      <div class="side-drawer-body">
        <div class="drawer-grid">
          <div class="drawer-field"><span>Client</span><strong>{{ printClient(oneDealslip) }}</strong></div>
          <div class="drawer-field"><span>Deal Date</span><strong>{{ oneDealslip.date }}</strong></div>
          <div class="drawer-field"><span>Sell</span><strong>{{ oneDealslip.sellAmount | number:'1.2-2' }} {{ oneDealslip.sellCurrency.code }}</strong></div>
          <div class="drawer-field"><span>Buy</span><strong>{{ oneDealslip.buyAmount | number:'1.2-2' }} {{ oneDealslip.buyCurrency.code }}</strong></div>
          <div class="drawer-field">
            <span>Rate</span>
            <strong>{{ oneDealslip.rate | number:'1.2-8' }}</strong>
            <small class="text-muted" *ngIf="dealslipMarketRate(oneDealslip)">{{ dealslipMarketRate(oneDealslip) }}</small>
          </div>
          <div class="drawer-field"><span>Created By</span><strong>{{ printAdminName(oneDealslip.createdBy) }}</strong></div>
          <div class="drawer-field"><span>Modified By</span><strong>{{ printAdminName(oneDealslip.lastModifiedBy) }}</strong></div>
          <div class="drawer-field"><span>Created</span><strong>{{ oneDealslip.created }}</strong></div>
          <div class="drawer-field"><span>Last Modified</span><strong>{{ oneDealslip.lastModified }}</strong></div>
        </div>
      </div>
    </aside>

    <app-footer></app-footer>
  </div>
</div>
